import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import { BrowserRouter as Router } from "react-router-dom";
import { LanguageProvider } from "./components/LanguageProvider";
import { fetchTranslations } from "./utils/index";

ReactDOM.render(
  <Router>
    <React.StrictMode>
    <LanguageProvider fetchTranslations={fetchTranslations}>
        <App />
      </LanguageProvider>
    </React.StrictMode>
  </Router>,
  document.getElementById("root")
);
